module.exports = __webpack_public_path__ + "img/p6.0d10672.png";